export enum FlowStates {
  BUSINESS_AS_USUAL = "BUSINESS_AS_USUAL",
  CAMERA_PROBLEM = "CAMERA_PROBLEM",
  UUID_NOT_FOUND = "UUID_NOT_FOUND",
  MARBLES = "MARBLES",
  MUST_GRANT_PERMISSION = "MUST_GRANT_PERMISSION",
  LOGGED_OUT = "LOGGED_OUT",
}



// WEBPACK FOOTER //
// ./src/constants/FlowStates.ts